export const selectWidgetsState = (state) => state.widgets;

export const selectAllWidgets = (state) => state.widgets.items;

export const selectWidgetById = (id) => (state) => state.widgets.byId[id];

export const selectAdvantages = selectWidgetById('estore_sidebar_slider_beside');

export const selectIsWidgetsLoading = (state) => state.widgets.loading.list;

export const selectWidgetsError = (state) => state.widgets.error.list;

export const widgetsSelectors = {
    selectWidgetsState,
    selectAllWidgets,
    selectWidgetById,
    selectIsWidgetsLoading,
    selectWidgetsError,
};